import {
  OmakasePolymorphicComponent,
  OmakasePolymorphicComponentProps,
  OmakasePolymorphicRootComponent,
} from '../utils/OmakasePolymorphicComponent';
import { Theme } from '@emotion/react';
import { listHeading, listHeadingContent, listHeadingTall } from './listHeadingCssDefs';
import React from 'react';

export type ListHeadingSize = 'medium' | 'large' | 'jumbo';

export interface ListHeadingProps {
  /**
   * Optional element after the content (e.g., a link)
   */
  elementEnd?: React.ReactNode;
  /**
   * The size of the header text content
   */
  size: ListHeadingSize;
  /**
   * Whether or not the item's vertical axis has increased margin
   */
  tall?: boolean;
}

const ListHeadingDefaultElement = 'li';
type ListHeadingTypeGuard = 'li';

const ListHeading: OmakasePolymorphicComponent<
  ListHeadingProps,
  typeof ListHeadingDefaultElement,
  ListHeadingTypeGuard
> = React.forwardRef(
  <E extends React.ElementType = typeof ListHeadingDefaultElement>(
    {
      children,
      component,
      elementEnd,
      size,
      tall = false,
      ...rest
    }: OmakasePolymorphicComponentProps<ListHeadingProps, E, ListHeadingTypeGuard>,
    ref: React.Ref<HTMLLIElement> | undefined
  ) => {
    const Component: React.ElementType = ListHeadingDefaultElement;

    return (
      <OmakasePolymorphicRootComponent
        css={(theme: Theme) => [listHeading(theme), tall && listHeadingTall(theme)]}
        ref={ref}
        component={Component}
        {...rest}
      >
        <span css={(theme: Theme) => listHeadingContent(theme, size)}>{children}</span>
        {elementEnd}
      </OmakasePolymorphicRootComponent>
    );
  }
);

export default ListHeading;
